module.exports = __webpack_public_path__ + "static/media/vector.5d12e479.svg";